{
  "status": {
    "success": {
      "title": "You're all set!",
      "subtitle": "Welcome to CuriPop! Your subscription is being activated — your family will have full access in just a moment.",
      "badge": "Subscription active"
    },
    "canceled": {
      "title": "No worries!",
      "subtitle": "No charge was made. You can come back and subscribe whenever you and your family are ready."
    },
    "unknown": {
      "title": "Hmm, something is off",
      "subtitle": "We could not confirm your checkout status. Head to your dashboard to check your subscription."
    }
  },
  "actions": {
    "go": "Go to Dashboard",
    "back": "Back to Dashboard",
    "retry": "Try again"
  }
}
